import "./About.css";
import heroImg from "../../assets/about/about-hero.jpg";
import aboutImg from "../../assets/about/about-main.jpg";

export default function About() {
  return (
    <div className="about-page">

      {/* HERO */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="about-hero-overlay">
          <h1>About Elvara Signatures</h1>
          <p>Crafting premium interiors with purpose & precision</p>
        </div>
      </section>

      {/* ABOUT CONTENT */}
      <section className="about-content">

        {/* WHO WE ARE */}
        <div className="about-block">
          <div className="about-text">
            <h2>Who We Are</h2>
            <p>
              Elvara Signatures is a design-driven interior firm delivering
              premium residential and commercial spaces. We believe interiors
              should feel timeless, functional, and deeply personal.
            </p>
            <p>
              From concept to execution, we manage everything with precision,
              transparency, and craftsmanship.
            </p>
          </div>

          <div className="about-image">
            <img src={aboutImg} alt="About Elvara Signatures" />
          </div>
        </div>

        {/* WHAT WE DO */}
        <div className="about-services">
          <h2>What We Do</h2>

          <div className="about-services-grid">
            <div className="service-card">Interior Design</div>
            <div className="service-card">Modular Kitchens & Wardrobes</div>
            <div className="service-card">Electrical Solutions</div>
            <div className="service-card">POP & False Ceiling</div>
          </div>
        </div>

        {/* WHY CHOOSE US */}
        <div className="about-why">
          <h2>Why Choose Us</h2>

          <ul>
            <li>✔ Turnkey end-to-end execution</li>
            <li>✔ Premium materials & finishes</li>
            <li>✔ Transparent pricing</li>
            <li>✔ Dedicated project management</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="about-cta">
          <h3>Let’s create a space you’ll love</h3>
          <button className="primary-btn">Contact Us</button>
        </div>

      </section>
    </div>
  );
}